import React from 'react';
import { Helmet } from 'react-helmet';
import { FaExternalLinkAlt, FaShoppingCart } from 'react-icons/fa';
import './styles/Panier.css';

const Panier = () => {
  const items = [
    {
      id: 1,
      name: "T-SHIRT - Les Z'ineuvitables",
      image: '/achat/tshirt face.png',
      description:
        '⚠️ CONTENU EN CRÉATION ⚠️ Les bénéfices iront à la trésorerie de la troupe, afin de continuer à proposer des spectacles de qualité et soutenir des causes solidaires.',
      price: ' € ',
      helloAssoLink:
        'https://www.helloasso.com/associations/amicale-laique-jules-ferry-59960-neuville-en-ferrain',
    },
    {
      id: 2,
      name: "Don - Les Z'ineuvitables",
      image: '/achat/don.svg',
      description:
        '⚠️ CONTENU EN CRÉATION ⚠️ Les dons iront à la trésorerie de la troupe, afin de pouvoir continuer à proposer des spectacles de qualité et soutenir des causes solidaires.',
      price: ' Montant libre ',
      helloAssoLink:
        'https://www.helloasso.com/associations/amicale-laique-jules-ferry-59960-neuville-en-ferrain',
    },
  ];

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Achat & Don | Les Z'ineuvitables - Soutenez la troupe</title>
        <meta
          name="description"
          content="Achetez le T-shirt officiel de la troupe Les Z'Ineuvitables ou faites un don pour soutenir nos projets théâtraux et solidaires."
        />
        <meta
          name="keywords"
          content="achat tshirt, don, théâtre, Neuville-en-Ferrain, solidarité, soutien troupe amateur"
        />
        <meta property="og:title" content="Boutique & Don | Les Z'ineuvitables" />
        <meta
          property="og:description"
          content="Achetez le T-shirt officiel de la troupe ou faites un don pour soutenir nos activités."
        />
        <meta property="og:url" content="https://www.zineuvitables.org/panier" />
        <meta property="og:image" content="https://www.zineuvitables.org/achat/tshirt%20face.png" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fr_FR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Boutique & Don | Les Z'ineuvitables" />
        <meta
          name="twitter:description"
          content="Achetez le T-shirt officiel de la troupe ou faites un don pour soutenir nos activités."
        />
        <meta name="twitter:image" content="https://www.zineuvitables.org/achat/tshirt%20face.png" />
      </Helmet>

      <div className="panier-container">
        <h2 className="title">
          <FaShoppingCart style={{ marginRight: '10px', verticalAlign: 'middle' }} />
          Achat ou Don - Soutenez la troupe !
        </h2>

        <div className="items-list">
          {items.map((item) => (
            <div key={item.id} className="item-card">
              {item.image && (
                <div className="item-image-container">
                  <img src={item.image} alt={item.name} className="item-image" />
                </div>
              )}
              
              <div className="item-details">
                <h3>{item.name}</h3>
                <p className="item-description">{item.description}</p>
                <p className="item-price">
                  <strong>{item.price}</strong>
                </p>
                <a
                  href={item.helloAssoLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="payment-button"
                >
                  Accéder à HelloAsso <FaExternalLinkAlt style={{ marginLeft: '8px' }} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Panier;